import styled from 'styled-components';
import * as variables from './../../assets/css/variables';

export const Container = styled.form`
  margin-left: auto;
  margin-right: auto;
  margin-top: 6.416428571428571rem;
  max-width: ${variables.MAX_WIDTH};
  
  fieldset {
    margin-bottom: 2.2857142857142856rem;
  }
  
  hr {
    border-top: none;
    border-left: none;
    border-right: none;
    border-bottom: 1px solid #EBEBEB;
    margin-top: 3.1785714285714284rem;
    margin-bottom: 3.1785714285714284rem;
  }
  
  @media (max-width: ${variables.TABLET}) {
      margin-left: ${variables.SPACING};
      margin-right: ${variables.SPACING};
      
      fieldset {
          margin-bottom: 1.7142857142857142rem;
      }
  }
`;

export const Title = styled.h1`
  font-size: 2rem;
  margin-bottom: 4.167857142857143rem;
  
  @media (max-width: ${variables.TABLET}) {
      font-size: 1.1428571428571428rem;
  }
`;

export const SubTitle = styled.h3`
  font-size: 1.7142857142857142rem;
  margin-bottom: 3.7692857142857146rem;
  
  @media (max-width: ${variables.TABLET}) {
      font-size: 1rem;
  }
`;

export const FormGroup = styled.div`
  display: flex;
  
  > div:first-child {
    flex: 1;
  }
  
  > div:last-child {
      margin-left: 2rem;
  }
  
  @media(max-width: ${variables.TABLET}) {
      > div:first-child {
        flex: 1;
      }
      
      > div:last-child {
        width: 5.678571428571429rem;
        flex: 0 0 5.678571428571429rem;
        display: flex;
        margin-left: 0.7142857142857143rem;
        
        input {
          width: 5.678571428571429rem;
        }
      }
  }
`;

export const ButtonGroup = styled.div`
    margin-top: 3.5714285714285716rem;
    margin-bottom: 7.37rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    
    button {
        width: 20rem;
        border-radius: 16rem !important;
        background-color: ${variables.COLOR_BLUE} !important;
        color: #FFF !important;
        font-size: 1.3rem !important;
    }
    
    @media (max-width: ${variables.TABLET}) {
        button {
            width: 13.360714285714286rem;
            font-size: 0.8571428571428571rem !important;
        }
    }
`;

export const GroupPets = styled.section`
    margin-bottom: 4.327857142857143rem;
    margin-left: auto;
    margin-right: auto;
    max-width: 62.142857142857146rem;
    
    > h1 {display: none;}
    
    @media (max-width: ${variables.TABLET}) {
        h1 {
            margin-bottom: 1.8407142857142857rem;
            padding: 0;
            font-size: 1rem;
        }   
    }
`;

export const Row = styled.div`
    width: 100%;
    
    @media (min-width: ${variables.TABLET}) {
        display: flex;
        justify-content: space-between;
        flex-wrap: ${props => props.grid === 'tablet' ? 'wrap' : 'no-wrap'};
        
        fieldset {
            flex-shrink: 0;
            flex-grow: 1;
                
            :not(:last-child) {
                margin-right: 2.1785714285714284rem;
            }
        }
    }
`;